import {
  RequestUserActivationRequest,
  User,
  UserPatchRequest,
} from '@interfaces/auth.interface';
import { UpdateCurrentUserRequest } from '@interfaces/user.interface';

import api from './';

export const {
  useRequestActivationMutation,
  useActivateMutation,
  useUpdateCurrentUserMutation,
  usePatchUserMutation,
} = api.injectEndpoints({
  endpoints: (build) => ({
    requestActivation: build.mutation<void, RequestUserActivationRequest>({
      query: (body) => ({
        url: `users/activate/request`,
        method: 'POST',
        body,
      }),
    }),
    activate: build.mutation<void, string>({
      query: (token) => ({
        url: `users/activate/${token}`,
        method: 'POST',
      }),
    }),
    updateCurrentUser: build.mutation<User, UpdateCurrentUserRequest>({
      query: (body) => ({
        url: 'users/current',
        method: 'PATCH',
        body,
      }),
    }),
    patchUser: build.mutation<User, UserPatchRequest>({
      query: (body) => ({
        url: 'users',
        method: 'PATCH',
        body,
      }),
    }),
  }),
});
